const state = {
    carts: [],
    cart: {},
    error: null
};

export default state;
